import { useHistory, useParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { usePantalla1 } from './usePantalla1';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getPaintInformed, getCancell, saveRefused } from '../../services/sampling/sampling';



export const useConsentimiento = () => {

    const history = useHistory();
    const { nimm, id_sample, is_curve } = useParams();
    const msgs = useRef(null);

    const [saveImg, setsaveImg] = useState("");
    const [iniImg, setIniImg] = useState("");
    const [dateInicial, setDateInicial] = useState("");
    const [createSweet] = useSweetAlert();
    const [counter, setCounter] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [hour, setHour] = useState('00');
    const [second, setSecond] = useState('00');
    const [minute, setMinute] = useState('00');
    const [difHourBrakfast, setDifHourBrakfast] = useState('00');
    const [difMinuteBrakfast, setDifMinuteBrakfast] = useState('00');

    // * INFORMED CONSENT
    const [InformedConsent, setInformedConsent] = useState([])
    console.log("🚀 ~ useConsentimiento ~ InformedConsent:", InformedConsent)
    const [selectedHour, setSelectedHour] = useState("");

    // * REFUSED SAMPLING
    const [listRefused, setListRefused] = useState([])
    const [id_cancellation_reazon_sample, setIdCancellationReazonSample] = useState(null);
    const [modalRefused, setModalRefused] = useState(false);



    const { fechaYHora } = usePantalla1();

    useEffect(() => {
        GetSettings();
    }, []);

    // ? CONFIGURATION INTERVAL TIMER
    useEffect(() => {

        let interValid;

        if (isActive) {

            interValid = setInterval(() => {

                let actual = new Date();
                let prueba = new Date(localStorage.getItem('timeInit'));
                let tiempoPasado = (actual - prueba);

                let segs = 1000;
                let mins = segs * 60;
                let hours = mins * 60;

                let horas = Math.floor(tiempoPasado / hours);

                tiempoPasado = tiempoPasado - (horas * hours);
                let minutos = Math.floor(tiempoPasado / mins);

                tiempoPasado = tiempoPasado - (minutos * mins);
                let segundos = Math.floor(tiempoPasado / segs);

                const computedSecond = String(segundos).length === 1 ? `0${segundos}` : segundos;
                const computedMinute = String(minutos).length === 1 ? `0${minutos}` : minutos;
                const computedHour = String(horas).length === 1 ? `0${horas}` : horas;

                setHour(computedHour);
                setMinute(computedMinute);
                setSecond(computedSecond);
                setCounter(counter => counter + 1);
            }, 1000);
        }
        return () => clearInterval(interValid);

    }, [history.location, counter]);


    useEffect(() => {
        var hoy = new Date();
        var fecha = hoy.getFullYear() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getDate();
        var hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds();
        setDateInicial(fecha + ' ' + hora);
        let copy = dateInicial

        if (copy == "") {
            copy = copy
        }

    }, [dateInicial])

    // ? CONFIGURATION NAVIGATE QUESTIONS
    const navigaConsentimientoInformado1 = (_nimm, id_sample) => {

        let nim = _nimm.substring(0, 13)
        let _consent = localStorage.getItem("consentimientoInformado");
        if (_consent === "true") {

            if (is_curve) {
                history.push('../../../sampling/' + nim + "/" + id_sample + "/" + is_curve);
            }
            else {
                history.push('../../concentimiento/' + nim + "/" + id_sample);
                console.log('../../concentimiento/' + nim + "/" + id_sample);
            }
        }
        else {
            history.push('../sampling/' + nim + "/" + id_sample);
        }
    }

    const navigateSampling = (_nimm) => {
        history.push('../sampling/' + _nimm + "/" + id_sample);
    }

    const navigateInicio = () => {
        history.push('/dashboard/defaultTomaDeMuestra');
    }


    // ? FIRM
    const handleChange = (myRef) => {
        const Draw = myRef.current;
        const data = Draw.getSaveData(); //imagen guardada
        setIniImg(data);
        setsaveImg(Draw.getDataURL('png'))
    }

    const repeatFirm = (myRef) => {
        const Draw = myRef.current;
        Draw.eraseAll();
        setsaveImg("");
    }


    // ? CONFIGURATION INFORMED CONSENT REQUEST
    const GetSettings = async () => {
        const listInformed = await getPaintInformed();

        if (listInformed.data.length > 0) {
            const cloned = JSON.parse(JSON.stringify(listInformed.data));

            cloned.forEach((q, i) => {
                q.visibility = (i === 0);
            });

            setInformedConsent(cloned);
        }
        else {
            setInformedConsent([]);
        }
    };

    const handleSelectOption = (questionIndex, reagentIndex, fromSubnivel = false) => {
        const updated = [...InformedConsent];
        const reagents = updated[questionIndex].listReagents;
        const selectedReagent = reagents[reagentIndex];

        reagents.forEach((r, i) => {
            r.selected_response = (i === reagentIndex);
            if (r.reagent === "NO APLICA") {
                r.numeric_value = null;
            }
        });


        if (updated[questionIndex + 1] && (!selectedReagent.sub_nivel || fromSubnivel || selectedReagent.reagent === "NO APLICA")) {
            updated[questionIndex].visibility = false;
            updated[questionIndex + 1].visibility = true;
        }

        setInformedConsent(updated);
    };

    const handleInputChange = (questionIndex, value, reagentIndex = null, subIndex = null) => {
        const updated = [...InformedConsent];

        if (reagentIndex !== null && subIndex !== null) {
            const subQuestion = updated[questionIndex].listReagents[reagentIndex]
                .alternativeQuestionsInformed[subIndex];

            subQuestion.comments = value;
        } else {
            updated[questionIndex].answer = value;

            if (updated[questionIndex].type === 5 && updated[questionIndex].listReagents?.length > 0) {
                updated[questionIndex].listReagents[0].selected_response = false;
            }

            if (
                updated[questionIndex].type !== 5 &&
                updated[questionIndex].type !== 1 &&
                value.trim() !== "" &&
                updated[questionIndex + 1]
            ) {
                updated[questionIndex].visibility = false;
                updated[questionIndex + 1].visibility = true;
            }
        }

        setInformedConsent(updated);
    };



    const handleBack = (questionIndex) => {
        const updated = [...InformedConsent];

        if (updated[questionIndex - 1]) {
            updated[questionIndex].visibility = false;
            updated[questionIndex - 1].visibility = true;
        }

        setInformedConsent(updated);
    };

    const handleAyuno = (questionIndex, timeString) => {
        const updated = [...InformedConsent];
        const reagents = updated[questionIndex].listReagents;

        const timeOptionIndex = reagents.findIndex(r => r.reagent === "Fecha/Hora");
        if (timeOptionIndex !== -1) {
            reagents.forEach((r, i) => {
                r.selected_response = (i === timeOptionIndex);
                r.numeric_value = (i === timeOptionIndex) ? timeString : null;
            });
        }

        if (updated[questionIndex + 1]) {
            updated[questionIndex].visibility = false;
            updated[questionIndex + 1].visibility = true;
        }

        setInformedConsent(updated);
        setSelectedHour("");
    };

    const calculateAyuno = (timeString) => {
        if (!timeString) return;

        const [hourStr, minuteStr] = timeString.split(":");
        const selectedDate = new Date();
        selectedDate.setHours(parseInt(hourStr), parseInt(minuteStr), 0, 0);

        const now = new Date();
        let diffMs = now - selectedDate;

        if (diffMs < 0) {
            diffMs += 24 * 60 * 60 * 1000;
        }

        const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMin = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        setDifHourBrakfast(String(diffHrs).padStart(2, "0"));
        setDifMinuteBrakfast(String(diffMin).padStart(2, "0"));


    };

    const handleFinish = async () => {

        const response = await saveRefused({
            nim: nimm.substring(0, 14),
            time_init: dateInicial,
            time_end: fechaYHora,
            cancellation: "",
            testCI: InformedConsent,
            imageFirm: saveImg,

        });

        if (response.code === 200) {
            history.push('../../sampling/' + nimm + "/" + id_sample);

        } else createSweet("wanirnig", "warning", response?.data?.message);

    };


    // ? CONFIGURATION REFUSED

    const toggleRefused = () => {
        setModalRefused(!modalRefused);
    };

    const handleCancell = () => {

        toggleRefused()
        GetCancell()

    }

    const GetCancell = async () => {

        const cancell = await getCancell();

        if (cancell?.data.length > 0) {

            const list = cancell?.data.map((form) => {
                return {
                    value: form.id_cancellation_reazon_sample,
                    label: form.cancellation_reazon,
                };
            });

            setListRefused(list);
        } else setListRefused([]);
    };

    const handleSelectValuesR = (selectedOption, field) => {
        if (field === "id_cancellation_reazon_sample") {
            setIdCancellationReazonSample(selectedOption);
        }
    };


    const refusedPatient = async () => {

        if (id_cancellation_reazon_sample === null) {
            msgs.current.show([
                {
                    severity: "error",
                    sticky: false,
                    detail: "Debes de seleccionar un motivo para rechazar esta toma",
                }
            ]);
            return;
        }

        const response = await saveRefused({
            nim: nimm.substring(0, 14),
            time_init: null,
            time_end: null,
            cancellation: id_cancellation_reazon_sample.value,
            testCI: [],
            imageFirm: "",
        });

        if (response.code === 200) {
            navigateInicio();
            setIdCancellationReazonSample(null)
            setListRefused([])
        } else createSweet("wanirnig", "warning", response?.data?.message);
    }



    return {
        navigaConsentimientoInformado1, navigateSampling,

        hour, minute, second, iniImg,
        difHourBrakfast, difMinuteBrakfast, repeatFirm,

        InformedConsent, handleSelectOption, handleInputChange, handleBack,
        handleAyuno, selectedHour, setSelectedHour, calculateAyuno,
        setInformedConsent, handleChange, handleFinish,

        modalRefused, toggleRefused, handleCancell, listRefused, id_cancellation_reazon_sample,
        handleSelectValuesR, msgs, refusedPatient,
    }
}


